/**
 * @generated SignedSource<<5926858e93ced5d94f1e213ba3544dd6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type FinalizeInvoiceInput = {
  id: string;
};
export type FinalizeInvoiceDialogFinalizeInvoiceMutation$variables = {
  input: FinalizeInvoiceInput;
};
export type FinalizeInvoiceDialogFinalizeInvoiceMutation$data = {
  readonly finalizeInvoice: {
    readonly " $fragmentSpreads": FragmentRefs<"FinalInvoiceView_invoice">;
  };
};
export type FinalizeInvoiceDialogFinalizeInvoiceMutation = {
  response: FinalizeInvoiceDialogFinalizeInvoiceMutation$data;
  variables: FinalizeInvoiceDialogFinalizeInvoiceMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "invoiceNumber",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "paymentMethodType",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cardBrand",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastFourDigits",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "paymentServiceType",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "state",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdAt",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "succeededAt",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "FinalizeInvoiceDialogFinalizeInvoiceMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Invoice",
        "kind": "LinkedField",
        "name": "finalizeInvoice",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "FinalInvoiceView_invoice"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "FinalizeInvoiceDialogFinalizeInvoiceMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Invoice",
        "kind": "LinkedField",
        "name": "finalizeInvoice",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "type",
            "storageKey": null
          },
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "CustomerAccount",
            "kind": "LinkedField",
            "name": "customerAccount",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "customerName",
                "storageKey": null
              },
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "customerNumber",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "vatId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "taxStatus",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "relatedInvoiceIdentifier",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "language",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "taxType",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "InvoiceLineItem",
            "kind": "LinkedField",
            "name": "lineItems",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "quantity",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "unitLabel",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "description",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "price",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "taxRatePercentage",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PaymentMethod",
            "kind": "LinkedField",
            "name": "paymentMethod",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v2/*: any*/),
              (v7/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "paymentTerms",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "expirationDate",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "sentAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "version",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "invoiceDate",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "dueDate",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "updatedAt",
            "storageKey": null
          },
          (v8/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "timeOfPerformanceStart",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "timeOfPerformanceEnd",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "taxTypeNote",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "BusinessAddress",
            "kind": "LinkedField",
            "name": "address",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "businessName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "addressLine1",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "addressLine2",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "postalCode",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "city",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "country",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "paymentNote",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "purchaseOrderReference",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "customerOrderNotes",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "InvoiceAttachment",
            "kind": "LinkedField",
            "name": "attachments",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "sha1",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "filename",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "size",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "documentSha1",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "documentRenderedAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "documentRenderedVersion",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "totalGrossAmount",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PaymentIntent",
            "kind": "LinkedField",
            "name": "paymentIntents",
            "plural": true,
            "selections": [
              (v2/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "canceledAt",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "scheduledFor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Charge",
                "kind": "LinkedField",
                "name": "charges",
                "plural": true,
                "selections": [
                  (v8/*: any*/),
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "paid",
                    "storageKey": null
                  },
                  (v10/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "disputed",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "refunded",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PaymentMethod",
                    "kind": "LinkedField",
                    "name": "paymentMethod",
                    "plural": false,
                    "selections": [
                      (v4/*: any*/),
                      (v7/*: any*/),
                      (v5/*: any*/),
                      (v6/*: any*/),
                      (v2/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "chargeFailureCode",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "chargeFailureMessage",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Refund",
            "kind": "LinkedField",
            "name": "refunds",
            "plural": true,
            "selections": [
              (v2/*: any*/),
              (v9/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "amount",
                "storageKey": null
              },
              (v10/*: any*/),
              (v11/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Invoice",
            "kind": "LinkedField",
            "name": "relatedInvoice",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "e2d2146da0baf085ea9b68d9191c124e",
    "id": null,
    "metadata": {},
    "name": "FinalizeInvoiceDialogFinalizeInvoiceMutation",
    "operationKind": "mutation",
    "text": "mutation FinalizeInvoiceDialogFinalizeInvoiceMutation(\n  $input: FinalizeInvoiceInput!\n) {\n  finalizeInvoice(input: $input) {\n    ...FinalInvoiceView_invoice\n    id\n  }\n}\n\nfragment CreateReverseInvoiceDialog_invoice on Invoice {\n  id\n  invoiceNumber\n  customerAccount {\n    customerName\n    id\n  }\n}\n\nfragment FinalInvoiceView_invoice on Invoice {\n  ...InvoiceHeader_invoice\n  ...InvoiceLineItemsTable_invoice\n  ...InitiateInvoicePaymentDialog_invoice\n  ...SendInvoiceDialog_invoice\n  ...CreateReverseInvoiceDialog_invoice\n  id\n  type\n  version\n  invoiceNumber\n  invoiceDate\n  dueDate\n  updatedAt\n  state\n  timeOfPerformanceStart\n  timeOfPerformanceEnd\n  language\n  taxType\n  taxTypeNote\n  customerAccount {\n    customerNumber\n    vatId\n    taxStatus\n    id\n  }\n  address {\n    businessName\n    addressLine1\n    addressLine2\n    postalCode\n    city\n    country\n  }\n  paymentNote\n  paymentMethod {\n    id\n    paymentMethodType\n    paymentServiceType\n    paymentTerms\n    cardBrand\n    expirationDate\n    lastFourDigits\n  }\n  purchaseOrderReference\n  customerOrderNotes\n  attachments {\n    sha1\n    filename\n    size\n  }\n  documentSha1\n  documentRenderedAt\n  documentRenderedVersion\n  sentAt\n  totalGrossAmount\n  paymentIntents {\n    id\n    status\n    createdAt\n    succeededAt\n    canceledAt\n    scheduledFor\n    charges {\n      state\n      id\n      paid\n      createdAt\n      disputed\n      refunded\n      paymentMethod {\n        paymentMethodType\n        paymentServiceType\n        cardBrand\n        lastFourDigits\n        id\n      }\n    }\n    chargeFailureCode\n    chargeFailureMessage\n  }\n  refunds {\n    id\n    status\n    amount\n    createdAt\n    succeededAt\n  }\n  relatedInvoice {\n    id\n    invoiceNumber\n  }\n}\n\nfragment InitiateInvoicePaymentDialog_invoice on Invoice {\n  id\n  invoiceNumber\n  paymentMethod {\n    paymentMethodType\n    cardBrand\n    lastFourDigits\n    id\n  }\n  sentAt\n}\n\nfragment InvoiceHeader_invoice on Invoice {\n  id\n  type\n  invoiceNumber\n  customerAccount {\n    customerName\n    id\n  }\n  relatedInvoiceIdentifier\n}\n\nfragment InvoiceLineItemsTable_invoice on Invoice {\n  id\n  type\n  language\n  taxType\n  lineItems {\n    quantity\n    unitLabel\n    description\n    price\n    taxRatePercentage\n  }\n}\n\nfragment SendInvoiceDialog_invoice on Invoice {\n  id\n  sentAt\n}\n"
  }
};
})();

(node as any).hash = "2bdb8079c922ac26800c9e24f16d838f";

export default node;
